// src/pages/Private/Student/StudentRequestForm.js
import { useState } from 'react';
import { submitStudentRequest } from '../../../services/studentRequestService';
import { useNavigate } from 'react-router-dom'; // YENİ
import '../../FormPage.css';

function StudentRequestForm() {
  const navigate = useNavigate(); // YENİ
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    note: '',
    password: ''
  });
  const [message, setMessage] = useState({ type: '', text: '' });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const response = await submitStudentRequest(formData);
      setMessage({ 
        type: 'success', 
        text: response.msg || '✅ Kayıt talebiniz başarıyla gönderildi! Admin onayından sonra giriş yapabilirsiniz.' 
      });
      
      // 3 saniye sonra login sayfasına yönlendir
      setTimeout(() => {
        navigate('/student-login');
      }, 3000);
      
      setFormData({ name: '', email: '', phone: '', note: '', password: '' });
    } catch (err) {
      console.error(err);
      setMessage({ 
        type: 'error', 
        text: err.response?.data?.msg || '❌ Bir hata oluştu. Lütfen tekrar deneyin.' 
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="form-wrapper">
      <div className="form-container">
        <div className="form-box">
          <div className="form-header">
            <div className="form-icon">📋</div>
            <h1>Student Registration Form</h1>
            <p>Register to start your leadership journey</p>
          </div>

          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-group">
              <label htmlFor="name">Full Name</label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Your full name"
                value={formData.name}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="example@email.com"
                value={formData.email}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone Number</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                placeholder="Your phone number"
                value={formData.phone}
                onChange={handleChange}
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                name="password"
                placeholder="Create a strong password"
                value={formData.password}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="note">Additional Notes</label>
              <textarea
                id="note"
                name="note"
                placeholder="Any additional notes you would like to add (optional)"
                value={formData.note}
                onChange={handleChange}
                rows="4"
                className="form-textarea"
              />
            </div>

            <button 
              type="submit" 
              className="form-button"
              disabled={isLoading}
            >
              {isLoading ? 'Submitting...' : 'Register'}
            </button>
          </form>

          {message.text && (
            <div className={`form-message ${message.type}`}>
              {message.text}
            </div>
          )}

          <div className="form-footer">
            <p>Already have an account? <a href="/student-login">Login here</a></p>
            <p><a href="/">← Back to home page</a></p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StudentRequestForm;